import actions from './actions';
import mutations from './mutations';
import { ISurvey } from './types';

const state: ISurvey = {
  reviewDataFlatMap: new Map(),
  reviewDataMap: new Map(),
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
